var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      class: ["courses-modal", { mobile: _vm.isMobile(_vm.$mq) }],
      attrs: { "show-close-button": "" },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "span",
          {
            staticClass: "level-num",
            style: { color: _vm.learningPath.color_scheme.s_500 }
          },
          [_vm._v("Level " + _vm._s(_vm.level.number))]
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "title" }, [_vm._v(_vm._s(_vm.level.title))]),
        _vm._v(" "),
        _c("p", { staticClass: "description" }, [
          _vm._v(_vm._s(_vm.level.intro_text))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "courses" },
        _vm._l(_vm.level.courses, function(course) {
          return _c(
            "a",
            {
              directives: [
                {
                  name: "track",
                  rawName: "v-track:click",
                  value: _vm.courseClickParams(course),
                  expression: "courseClickParams(course)",
                  arg: "click"
                }
              ],
              key: course.slug,
              class: [
                "course",
                {
                  complete: _vm.isComplete(course),
                  recommended: _vm.continueCourseSlug === course.slug
                }
              ],
              attrs: {
                href:
                  "/courses/" +
                  course.slug +
                  "/?from_llp=" +
                  _vm.learningPath.slug
              }
            },
            [
              _c("div", { staticClass: "image" }, [
                _c("img", {
                  staticClass: "image",
                  attrs: { src: course.image_url, alt: "" }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "info" },
                [
                  _c("h2", { staticClass: "name" }, [
                    _vm._v(_vm._s(course.name))
                  ]),
                  _vm._v(" "),
                  course.num_lessons > 0
                    ? _c("span", { staticClass: "lesson-number" }, [
                        _vm._v(
                          _vm._s(course.num_lessons) + " lessons\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isComplete(course)
                    ? _c("ProgressBar", {
                        attrs: { "percent-complete": course.percent_complete }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.isComplete(course)
                ? _c("CircleCheckMarkIcon", { staticClass: "completed-check" })
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }